export default __webpack_public_path__ + "static/media/vintage45g-5.0adfe157.jpg";